module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_G170087.4c0cf57c.png";